<template>
  <div class="row mt-4 ml-md-4">
    <div class="col-md-12 pt-3">
      <div class="row">
        <div class="col-md-4 col-6">
          <div class="info-text-title">
            Autor:
          </div>
          <p class="info-text">
            {{ book.author }}
          </p>
        </div>
        <div class="col-md-4 col-6">
          <div class="info-text-title">
            ISBN:
          </div>
          <p class="info-text">
            {{ book.isbn }}
          </p>
        </div>
        <div class="col-md-4 col-6">
          <div class="info-text-title">
            Casa Editorial:
          </div>
          <p class="info-text">
            {{ book.publisher }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BookRequestAdditionalInformation',
  props: {
    book: {
      type: Object,
      required: true,
      default() {
        return {
          author: '',
          isbn: '',
          publisher: '',
        };
      },
    },
  },
};
</script>

<style scoped>
.info-text {
  color: #11291b !important;
}
.info-text-title {
  color: #727272 !important;
  font-size: 14px !important;
  font-weight: normal;
}

@media only screen and (max-width: 375px) {
  .info-text-title {
    color: #727272 !important;
    font-size: 12px !important;
    font-weight: normal;
  }
  .info-text {
    color: #11291b !important;
    font-weight: normal;
    font-size: 12px;
  }
}
</style>
